import { render } from "./TaskList.vue?vue&type=template&id=2bd0b74b&scoped=true&ts=true"
import script from "./TaskList.vue?vue&type=script&lang=ts"
export * from "./TaskList.vue?vue&type=script&lang=ts"

import "./TaskList.vue?vue&type=style&index=0&id=2bd0b74b&lang=less"
import "./TaskList.vue?vue&type=style&index=1&id=2bd0b74b&scoped=true&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd0b74b"]])

export default __exports__